import axios from "axios";

export default axios.create({
  // baseURL: "http://62.171.153.83:8080/tappme-api/"
  // baseURL: "https://tappme-api.digitalnoticeboard.biz/tappme-api-development/",
  baseURL: "https://tappme-api.digitalnoticeboard.biz/tappme-api-staging/",
  // baseURL: "http://62.171.153.83:8080/tappme-api-staging/",
  // baseURL: "http://localhost:8080",
});
